import React from "react";
import { EditContentModalShell } from "./EditContentModalShell";

type EditContentLoadingStateProps = {
    onClose: () => void;
};

export const EditContentLoadingState: React.FC<EditContentLoadingStateProps> = ({ onClose }) => (
    <EditContentModalShell onClose={onClose}>
        <div className="loading-spinner" style={{ margin: "0 auto 20px" }}>
            <div
                style={{
                    border: "4px solid #f3f3f3",
                    borderTop: "4px solid #3498db",
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    animation: "spin 1s linear infinite",
                    margin: "0 auto",
                }}
            />
        </div>
        <h3>Fetching Latest Data...</h3>
        <p style={{ color: "#8B92A6" }}>Loading current configuration from API</p>
    </EditContentModalShell>
);
